import React from 'react';
import { IEditorProps } from './Editor';
import { EditorTextField } from './EditorTextField';

interface IPasswordEditorProps extends IEditorProps {}

/**
 * Text field editor, with type set to password.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function PasswordEditor(props: IPasswordEditorProps) {
  return <EditorTextField {...props} inputType="password" />;
}
